import C3ServerlessBundle from './C3ServerlessBundle';

const c3bundle = new C3ServerlessBundle();

declare global {
  interface Window {
    c3bundle: any;
  }
}

window.c3bundle = window.c3bundle || c3bundle;

export default c3bundle;
